import React from 'react';

export default function Users() {
  return (
    <svg width="20" height="18" viewBox="0 0 20 18">
      <path d="M20,14.11a.74.74,0,0,1-.08.53.64.64,0,0,1-.44.28,27.59,27.59,0,0,1-3.58.24A7.57,7.57,0,0,0,13.09,12a8.33,8.33,0,0,0-1.36-.63,2.56,2.56,0,0,0-.33-.16c2.06-3.43,1.71-6,.85-7.45A4.85,4.85,0,0,0,10,1.53,3,3,0,0,1,12.65,0a3.72,3.72,0,0,1,3.27,1.9c.9,1.55.67,3.45-.69,5.66A2.07,2.07,0,0,0,14.75,9c.15.5,1,.83,1.67,1.14a6.65,6.65,0,0,1,1.1.52A5.33,5.33,0,0,1,20,14.11ZM7.33,18a50.44,50.44,0,0,1-6.79-.28A.65.65,0,0,1,0,16.91a5.38,5.38,0,0,1,2.44-3.45,11.28,11.28,0,0,1,1.1-.53c.71-.3,1.52-.63,1.67-1.13a2.17,2.17,0,0,0-.46-1.45c-1.35-2.2-1.6-4.1-.71-5.65a3.79,3.79,0,0,1,6.57,0c.89,1.55.64,3.45-.71,5.65a2.17,2.17,0,0,0-.46,1.45c.15.5,1,.83,1.67,1.13a11.28,11.28,0,0,1,1.1.53,5.48,5.48,0,0,1,2.46,3.45.68.68,0,0,1-.54.81A51.08,51.08,0,0,1,7.33,18Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/Users/index.js